export class RiskRegisterFormModel{
    id:number = 0;
    categoryId: number = -1; //default -1
    componentId: number = -1;
    risk: string = '';
    mitigationPlan: string = '';
    registeredBy: string = '';
    status: string = '';
    closerDate: string = '';
    comments: string = '';
    isNew : boolean = true;
}